<template>
  <v-content class="mb-5">
  <v-layout justify-center v-if="years!=null && years.length > 0">
    <v-flex xs12 sm10 md10>
      <v-card flat color="transparent">
        <v-card-title class="headline font-weight-thin bluetext mt-1">
          {{'CHANGELOG_TITLE' | translate}}
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
    <v-layout v-if="years!=null && years.length > 0">
      <v-flex xs12>
    <v-timeline>
      <v-timeline-item
        v-for="(year, i) in years"
        :key="i"
        color="#8ACAC1"
        small
        right
      >
        <template v-slot:opposite>
        <span
          class="subheading font-weight-bold bluetext"
          v-text="getDateStringOf(year.changeDate)"
        ></span>
        </template>
        <div class="py-3 textleft">
          <div class="body-2" v-html="year.Aenderung">
          </div>
        </div>
      </v-timeline-item>
    </v-timeline>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
export default {
  name: 'ChangelogEValueRate',
  components: {},
  data () {
    return {
        years: null
    }
  },
  methods: {
    getDateStringOf: function (value){
      return moment(String(value)).format('DD.MM.YYYY')
    },
    onGetChangeLogData: function (data) {
      this.years = data
    },
    update() {
      Vue.prototype.$api.getChangeLogData(this.onGetChangeLogData)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/ChangelogEValueRate.vue